module.exports = __webpack_public_path__ + "static/media/upload-icon.71fb1510.svg";